<script lang="ts">
    import MinusIcon from "../../../icons/MinusIcon.svelte";
    import PlusIcon from "../../../icons/PlusIcon.svelte";
    import Control from "../controls/Control.svelte";
    import type { ZoomControlManager } from "./ZoomControlManager";

    export let manager: ZoomControlManager;
    
    const onZoomIn = () => {
        manager.zoomIn();
    };

    const onZoomOut = () => {
        manager.zoomOut();
    };
</script>

<Control class="zoom-control bg-white">
    <div class="d-flex flex-column justify-content-center align-items-center p-1">
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <button on:click={onZoomIn} class="border-0 bg-transparent toolbox-button mb-1">
            <PlusIcon class="zoom-button"/>
        </button>
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <button on:click={onZoomOut} class="border-0 bg-transparent toolbox-button mb-1">
            <MinusIcon class="zoom-button"/>
        </button>
    </div>
</Control>